var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _rect331, _rect332, _rect333, _rect334, _rect335, _rect336, _rect337, _rect338, _rect339, _rect340, _rect341, _rect342, _rect343, _rect344, _rect345, _rect346, _rect347, _rect348, _rect349;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPixelArtPikachu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 816,
    height: 736,
    viewBox: "0 0 816 736",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 64,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 64,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 32,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 32,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 64,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 96,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 128,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 160,
    width: 32,
    height: 32,
    fill: "#56321C"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 192,
    width: 32,
    height: 32,
    fill: "#56321C"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 224,
    width: 32,
    height: 32,
    fill: "#56321C"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 256,
    width: 32,
    height: 32,
    fill: "#8D541E"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 256,
    width: 32,
    height: 32,
    fill: "#8D541E"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 224,
    width: 32,
    height: 32,
    fill: "#88541C"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 224,
    width: 32,
    height: 32,
    fill: "#88541C"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 224,
    width: 32,
    height: 32,
    fill: "#855720"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 224,
    width: 32,
    height: 32,
    fill: "#88541C"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 224,
    width: 32,
    height: 32,
    fill: "#855720"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 224,
    width: 32,
    height: 32,
    fill: "#88541C"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 256,
    width: 32,
    height: 32,
    fill: "#D18B31"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 256,
    width: 32,
    height: 32,
    fill: "#8D5920"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 464,
    y: 224,
    width: 32,
    height: 32,
    fill: "#8B5220"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 224,
    width: 32,
    height: 32,
    fill: "#8B5220"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 192,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 192,
    width: 32,
    height: 32,
    fill: "#88531D"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 592,
    y: 160,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 624,
    y: 160,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 656,
    y: 160,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 656,
    y: 192,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 592,
    y: 192,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 624,
    y: 192,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 624,
    y: 224,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 592,
    y: 224,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 592,
    y: 256,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 592,
    y: 288,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 288,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 288,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 224,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 224,
    width: 32,
    height: 32,
    fill: "#DFB345"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 256,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 256,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 288,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 256,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 464,
    y: 288,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 320,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 320,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 464,
    y: 320,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 317,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 288,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 288,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 308,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 340,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 352,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 464,
    y: 352,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 384,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 464,
    y: 384,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 416,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 464,
    y: 416,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 448,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 464,
    y: 448,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 436,
    width: 32,
    height: 32,
    fill: "#E6B945"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 468,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 464,
    y: 480,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 480,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 480,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 468,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 480,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 468,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 480,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 468,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 480,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 512,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 512,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 480,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 512,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 544,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 544,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 512,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 480,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 464,
    y: 256,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 624,
    y: 256,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 656,
    y: 224,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 656,
    y: 130,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 688,
    y: 130,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 688,
    y: 160,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 194,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 688,
    y: 192,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 224,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 688,
    y: 224,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 688,
    y: 256,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 656,
    y: 256,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 130,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 162,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 752,
    y: 192,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 752,
    y: 160,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 784,
    y: 160,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 752,
    y: 224,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 256,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 688,
    y: 288,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 656,
    y: 288,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 624,
    y: 288,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 624,
    y: 320,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 592,
    y: 320,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 320,
    width: 32,
    height: 32,
    fill: "#80521F"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 352,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 384,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 416,
    width: 32,
    height: 32,
    fill: "#593319"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 448,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 480,
    width: 32,
    height: 32,
    fill: "#633C22"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 512,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 544,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 576,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 640,
    width: 32,
    height: 32,
    fill: "#593211"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 608,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 464,
    y: 672,
    width: 32,
    height: 32,
    fill: "#8B541C"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 672,
    width: 32,
    height: 32,
    fill: "#8B541C"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 672,
    width: 32,
    height: 32,
    fill: "#E6B945"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 672,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 384,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 416,
    width: 32,
    height: 32,
    fill: "#706B6B"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 416,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 448,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 480,
    width: 32,
    height: 32,
    fill: "#BE9232"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 480,
    width: 32,
    height: 32,
    fill: "#633617"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 480,
    width: 32,
    height: 32,
    fill: "#845445"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 512,
    width: 32,
    height: 32,
    fill: "#603E33"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 512,
    width: 32,
    height: 32,
    fill: "#845445"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 512,
    width: 32,
    height: 32,
    fill: "#845445"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 512,
    width: 32,
    height: 32,
    fill: "#845445"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 512,
    width: 32,
    height: 32,
    fill: "#BE9232"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 372,
    width: 32,
    height: 32,
    fill: "#737373"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 404,
    width: 32,
    height: 32,
    fill: "#706B6B"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 340,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 372,
    width: 32,
    height: 32,
    fill: "#706B6B"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 404,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 372,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 404,
    width: 32,
    height: 32,
    fill: "#737373"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 404,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 436,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 436,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 340,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 512,
    width: 32,
    height: 32,
    fill: "#EC0505"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 544,
    width: 32,
    height: 32,
    fill: "#950909"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 512,
    width: 32,
    height: 32,
    fill: "#EC0505",
    fillOpacity: 0.19
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 544,
    width: 32,
    height: 32,
    fill: "#EC0505"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 512,
    width: 32,
    height: 32,
    fill: "#EC0505",
    fillOpacity: 0.19
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 544,
    width: 32,
    height: 32,
    fill: "#EC0505"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 512,
    width: 32,
    height: 32,
    fill: "#EC0505",
    fillOpacity: 0.19
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 544,
    width: 32,
    height: 32,
    fill: "#EC0505"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 352,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 784,
    y: 192,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    y: 96,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    y: 128,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 128,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 160,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 192,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 160,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 160,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 192,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 192,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 192,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 224,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 256,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 256,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 256,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 224,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 224,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 320,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 320,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 352,
    width: 32,
    height: 32,
    fill: "#E7B34A"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 352,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 288,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 288,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 128,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 128,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 96,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 96,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 96,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    y: 160,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    y: 192,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 224,
    width: 32,
    height: 32,
    fill: "#56330F"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 256,
    width: 32,
    height: 32,
    fill: "#56330F"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 288,
    width: 32,
    height: 32,
    fill: "#5E2F11"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 320,
    width: 32,
    height: 32,
    fill: "#845521"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 352,
    width: 32,
    height: 32,
    fill: "#563B22"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 384,
    width: 32,
    height: 32,
    fill: "#563B22"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 416,
    width: 32,
    height: 32,
    fill: "#563B22"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 448,
    width: 32,
    height: 32,
    fill: "#8B561C"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 480,
    width: 32,
    height: 32,
    fill: "#573519"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 512,
    width: 32,
    height: 32,
    fill: "#573519"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 544,
    width: 32,
    height: 32,
    fill: "#573519"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 640,
    width: 32,
    height: 32,
    fill: "#8B541C"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 672,
    width: 32,
    height: 32,
    fill: "#8B541C"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 672,
    width: 32,
    height: 32,
    fill: "#8B541C"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 672,
    width: 32,
    height: 32,
    fill: "#E6B945"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 672,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 672,
    width: 32,
    height: 32,
    fill: "#8B541C"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 672,
    width: 32,
    height: 32,
    fill: "#8B541C"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 704,
    width: 32,
    height: 32,
    fill: "#8B541C"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 704,
    width: 32,
    height: 32,
    fill: "#8B541C"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 704,
    width: 32,
    height: 32,
    fill: "#8B541C"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 704,
    width: 32,
    height: 32,
    fill: "#8B541C"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 704,
    width: 32,
    height: 32,
    fill: "#8B541C"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 704,
    width: 32,
    height: 32,
    fill: "#8B541C"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 704,
    width: 32,
    height: 32,
    fill: "#8B541C"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 640,
    width: 32,
    height: 32,
    fill: "#E6B945"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 464,
    y: 640,
    width: 32,
    height: 32,
    fill: "#E6B945"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 640,
    width: 32,
    height: 32,
    fill: "#E6B945"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 704,
    width: 32,
    height: 32,
    fill: "#8B541C"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 640,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 640,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 640,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 640,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 640,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 640,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 640,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 640,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 640,
    width: 32,
    height: 32,
    fill: "#E6B945"
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 608,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 608,
    width: 32,
    height: 32,
    fill: "#E6B945"
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 608,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 464,
    y: 608,
    width: 32,
    height: 32,
    fill: "#E6B945"
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 576,
    width: 32,
    height: 32,
    fill: "#E6B945"
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 464,
    y: 576,
    width: 32,
    height: 32,
    fill: "#E6B945"
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 608,
    width: 32,
    height: 32,
    fill: "#E6B945"
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 576,
    width: 32,
    height: 32,
    fill: "#E6B945"
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 576,
    width: 32,
    height: 32,
    fill: "#E6B945"
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 576,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 576,
    width: 32,
    height: 32,
    fill: "#E6B945"
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 640,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 608,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 608,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 608,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 608,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 608,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 576,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 544,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 512,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 576,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 544,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 544,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 512,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 576,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 576,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 544,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 512,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 496,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 496,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 480,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 480,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 448,
    width: 32,
    height: 32,
    fill: "#844F23"
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 512,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 480,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 544,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 544,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 512,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 480,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 448,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 416,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 384,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 352,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 384,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 352,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 384,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 352,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 384,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 416,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 448,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 432,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 448,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 448,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 432,
    width: 32,
    height: 32,
    fill: "#633617"
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 432,
    width: 32,
    height: 32,
    fill: "#BE9232"
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    x: 281,
    y: 384,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 448,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 352,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 384,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 352,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 384,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 352,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 384,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 400,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 352,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 384,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 400,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 352,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 384,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 352,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 384,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 400,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 416,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 448,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 436,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 384,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 352,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 340,
    width: 32,
    height: 32,
    fill: "#E6B945"
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 324,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 292,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 288,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 288,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 288,
    width: 32,
    height: 32,
    fill: "#F4EFAC"
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 288,
    width: 32,
    height: 32,
    fill: "#F4EFAC"
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 288,
    width: 32,
    height: 32,
    fill: "#F4EFAC"
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 288,
    width: 32,
    height: 32,
    fill: "#F4EFAC"
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 320,
    width: 32,
    height: 32,
    fill: "#F4EFAC"
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 320,
    width: 32,
    height: 32,
    fill: "#F4EFAC"
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 320,
    width: 32,
    height: 32,
    fill: "#F4EFAC"
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 320,
    width: 32,
    height: 32,
    fill: "#F4EFAC"
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 288,
    width: 32,
    height: 32,
    fill: "#F4EFAC"
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 320,
    width: 32,
    height: 32,
    fill: "#F4EFAC"
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 288,
    width: 32,
    height: 32,
    fill: "#F4EFAC"
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 320,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 352,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 256,
    width: 32,
    height: 32,
    fill: "#C69136"
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 256,
    width: 32,
    height: 32,
    fill: "#F4EFAC"
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 256,
    width: 32,
    height: 32,
    fill: "#F4EFAC"
  })), _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 256,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 256,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 256,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 288,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 308,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 288,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 308,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 480,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 576,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 544,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 576,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 544,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 544,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 544,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 544,
    width: 32,
    height: 32,
    fill: "#E8DD63"
  })), _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 544,
    width: 32,
    height: 32,
    fill: "#ECDC6A"
  })), _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 608,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 576,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 608,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 672,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 672,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 672,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 672,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 672,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 672,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 672,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 672,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 576,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 608,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 576,
    width: 32,
    height: 32,
    fill: "#E4BA45"
  })), _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 576,
    width: 32,
    height: 32,
    fill: "#950909"
  })), _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 608,
    width: 32,
    height: 32,
    fill: "#8B541C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixelArtPikachu);
export default __webpack_public_path__ + "static/media/pixel-art-pikachu.c1b793c2e1fc2c605104146e23701ee6.svg";
export { ForwardRef as ReactComponent };